<template>
  <svg class="ia" :class="'ia-' + scene" viewBox="0 0 120 96" :width="size" :height="size * 0.8" aria-hidden="true" focusable="false">
    <!-- The floor every scene stands on. -->
    <ellipse class="ia-floor" cx="60" cy="84" rx="38" ry="4" />

    <g v-if="scene === 'count'">
      <rect class="ia-paper" x="36" y="16" width="48" height="62" rx="6" />
      <rect class="ia-clip" x="49" y="11" width="22" height="10" rx="3" />
      <rect class="ia-bar" x="57" y="31" width="20" height="4" rx="2" />
      <rect class="ia-bar" x="57" y="45" width="16" height="4" rx="2" />
      <rect class="ia-bar" x="57" y="59" width="18" height="4" rx="2" />
      <path class="ia-tick t1" d="M43 33l3 3 6-6" />
      <path class="ia-tick t2" d="M43 47l3 3 6-6" />
      <path class="ia-tick t3" d="M43 61l3 3 6-6" />
    </g>

    <g v-else-if="scene === 'delivery'">
      <path class="ia-speed s1" d="M22 42h14" />
      <path class="ia-speed s2" d="M16 52h20" />
      <path class="ia-speed s3" d="M24 62h12" />
      <g class="ia-bob">
        <path class="ia-paper" d="M46 38l16-8 16 8v22l-16 8-16-8z" />
        <path class="ia-line" d="M46 38l16 8 16-8M62 46v22" />
        <path class="ia-accent" d="M54 34l16 8v8" />
      </g>
    </g>

    <g v-else-if="scene === 'chart'">
      <path class="ia-line" d="M26 76h70" />
      <rect class="ia-col c1" x="32" y="58" width="11" height="18" rx="2" />
      <rect class="ia-col c2" x="48" y="46" width="11" height="30" rx="2" />
      <rect class="ia-col c3" x="64" y="52" width="11" height="24" rx="2" />
      <rect class="ia-col c4 is-top" x="80" y="34" width="11" height="42" rx="2" />
      <path class="ia-trend" d="M37 52l16-12 16 6 16-16" />
    </g>

    <g v-else-if="scene === 'allclear'">
      <circle class="ia-halo" cx="60" cy="46" r="26" />
      <circle class="ia-okring" cx="60" cy="46" r="26" />
      <path class="ia-ok" d="M48 46l8 8 16-17" />
      <path class="ia-spark k1" d="M28 22v8M24 26h8" />
      <path class="ia-spark k2" d="M94 26v6M91 29h6" />
      <path class="ia-spark k3" d="M90 68v8M86 72h8" />
    </g>

    <g v-else-if="scene === 'store'">
      <rect class="ia-paper" x="36" y="34" width="48" height="38" rx="2" />
      <path class="ia-awning" d="M32 34l5-12h46l5 12z" />
      <path class="ia-awning-line" d="M44 22l-2 12M56 22l-1 12M68 22l1 12M80 22l2 12" />
      <rect class="ia-soft" x="41" y="41" width="11" height="10" rx="1.5" />
      <rect class="ia-soft" x="68" y="41" width="11" height="10" rx="1.5" />
      <rect class="ia-line-box" x="55" y="50" width="11" height="22" rx="1" />
      <g class="ia-tap"><path class="ia-pointer" d="M86 56l12 5-5 2 4 6-3 2-4-6-4 4z" /></g>
    </g>

    <g v-else-if="scene === 'recipe'">
      <rect class="ia-paper" x="32" y="16" width="56" height="62" rx="6" />
      <path class="ia-slice" d="M42 26h18l-9 16z" />
      <circle class="ia-dot" cx="48" cy="30" r="1.6" />
      <circle class="ia-dot" cx="53" cy="33" r="1.6" />
      <path class="ia-write w1" d="M66 30h14" />
      <path class="ia-write w2" d="M42 50h36" />
      <path class="ia-write w3" d="M42 59h30" />
      <path class="ia-write w4" d="M42 68h24" />
    </g>

    <g v-else-if="scene === 'search'">
      <rect class="ia-paper" x="28" y="18" width="50" height="60" rx="6" />
      <rect class="ia-bar" x="36" y="30" width="30" height="4" rx="2" />
      <rect class="ia-bar" x="36" y="42" width="24" height="4" rx="2" />
      <rect class="ia-bar" x="36" y="54" width="28" height="4" rx="2" />
      <g class="ia-scan">
        <circle class="ia-lens" cx="74" cy="50" r="12" />
        <path class="ia-handle" d="M83 59l9 9" />
      </g>
    </g>

    <g v-else-if="scene === 'error'">
      <path class="ia-line" d="M10 48h30" />
      <g class="ia-sway">
        <rect class="ia-paper" x="40" y="39" width="15" height="18" rx="3" />
        <path class="ia-line" d="M55 43h7M55 53h7" />
      </g>
      <path class="ia-zap" d="M66 38l3 6-4 1 3 7" />
      <rect class="ia-paper" x="72" y="37" width="16" height="22" rx="3" />
      <path class="ia-line" d="M77 44v3M83 44v3M88 48h22" />
    </g>

    <g v-else-if="scene === 'loading'">
      <path class="ia-layer y3" d="M38 62l22 11 22-11" />
      <path class="ia-layer y2" d="M38 50l22 11 22-11" />
      <path class="ia-layer y1 is-top" d="M60 27l22 11-22 11-22-11z" />
    </g>

    <g v-else-if="scene === 'dough'">
      <g class="ia-rise">
        <path class="ia-doughball" d="M30 66a30 20 0 0 1 60 0c0 6-13.4 10-30 10s-30-4-30-10z" />
        <path class="ia-line" d="M44 60c4-4 8-4 12 0s8 4 12 0" />
      </g>
      <path class="ia-steam m1" d="M48 34c0-4 4-5 4-9" />
      <path class="ia-steam m2" d="M60 30c0-4 4-5 4-9" />
      <path class="ia-steam m3" d="M72 34c0-4 4-5 4-9" />
    </g>

    <g v-else>
      <path class="ia-paper" d="M38 50h44v26H38z" />
      <path class="ia-line" d="M38 50l-7-9h24l5 9M82 50l7-9H65l-5 9" />
      <rect class="ia-drop" x="54" y="16" width="12" height="12" rx="3" />
    </g>
  </svg>
</template>

<script>
const SCENES = ["count", "delivery", "chart", "allclear", "store", "recipe", "search", "error", "loading", "dough", "box"];

/**
 * Small drawings for the moments a page has nothing to show yet, is loading or could not load: what the page is
 * about, moving gently, so the empty space says what to do instead of looking broken. Colours are the theme's;
 * nothing moves for people who ask for less motion.
 */
export default {
  name: "InvArt",
  props: {
    name: { type: String, default: "box" },
    size: { type: Number, default: 120 },
  },
  computed: {
    scene() {
      return SCENES.includes(this.name) ? this.name : "box";
    },
  },
};
</script>

<style scoped>
.ia { display: block; overflow: visible; }
.ia * { transform-box: fill-box; }
.ia-floor { fill: var(--bg-tertiary); opacity: 0.9; }
.ia-paper { fill: var(--bg-tertiary); stroke: var(--border-secondary); stroke-width: 1.6; }
.ia-clip { fill: var(--accent-primary-bg); stroke: var(--accent-primary); stroke-width: 1.6; }
.ia-bar { fill: var(--border-secondary); }
.ia-line, .ia-line-box { fill: none; stroke: var(--text-muted); stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; opacity: 0.75; }
.ia-accent { fill: none; stroke: var(--accent-primary); stroke-width: 2.4; stroke-linecap: round; stroke-linejoin: round; }
.ia-soft { fill: var(--accent-primary-bg); }
.ia-tick, .ia-trend, .ia-write, .ia-ok { fill: none; stroke-linecap: round; stroke-linejoin: round; }
.ia-tick { stroke: var(--accent-primary); stroke-width: 2.6; stroke-dasharray: 16; stroke-dashoffset: 0; }
.ia-speed { stroke: var(--text-muted); stroke-width: 2; stroke-linecap: round; opacity: 0.6; }
.ia-col { fill: var(--accent-primary-bg); stroke: color-mix(in srgb, var(--accent-primary) 45%, transparent); stroke-width: 1.2; transform-origin: 50% 100%; }
.ia-col.is-top { fill: var(--accent-primary); stroke: none; }
.ia-trend { stroke: var(--text-primary); stroke-width: 2; stroke-dasharray: 80; opacity: 0.7; }
.ia-halo { fill: var(--success-bg); }
.ia-okring { fill: none; stroke: var(--success); stroke-width: 2; opacity: 0.55; transform-origin: center; }
.ia-ok { stroke: var(--success); stroke-width: 4; stroke-dasharray: 40; }
.ia-spark { stroke: var(--accent-primary); stroke-width: 2; stroke-linecap: round; transform-origin: center; }
.ia-awning { fill: var(--accent-primary); }
.ia-awning-line { stroke: rgba(255, 255, 255, 0.55); stroke-width: 1.6; fill: none; }
.ia-pointer { fill: var(--text-primary); stroke: var(--bg-primary); stroke-width: 1.4; stroke-linejoin: round; }
.ia-slice { fill: var(--accent-primary-bg); stroke: var(--accent-primary); stroke-width: 1.8; stroke-linejoin: round; }
.ia-dot { fill: var(--accent-primary); }
.ia-write { stroke: var(--border-secondary); stroke-width: 3.2; stroke-dasharray: 40; }
.ia-lens { fill: color-mix(in srgb, var(--bg-primary) 55%, transparent); stroke: var(--accent-primary); stroke-width: 3; }
.ia-handle { stroke: var(--accent-primary); stroke-width: 4.5; stroke-linecap: round; }
.ia-zap { fill: none; stroke: var(--accent-primary); stroke-width: 2.4; stroke-linecap: round; stroke-linejoin: round; }
.ia-layer { fill: var(--accent-primary-bg); stroke: var(--accent-primary); stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.ia-layer.is-top { fill: var(--accent-primary); }
.ia-doughball { fill: #f5e6c8; stroke: #d9b77c; stroke-width: 1.6; transform-origin: 50% 100%; }
.ia-steam { fill: none; stroke: var(--text-muted); stroke-width: 2; stroke-linecap: round; opacity: 0; }
.ia-drop { fill: var(--accent-primary); }

@media (prefers-reduced-motion: no-preference) {
  .ia-tick { animation: ia-tick 3.6s var(--iw-ease, ease-out) infinite; stroke-dashoffset: 16; }
  .ia-tick.t2 { animation-delay: 0.45s; }
  .ia-tick.t3 { animation-delay: 0.9s; }
  .ia-bob { animation: ia-bob 2.4s ease-in-out infinite; }
  .ia-speed { animation: ia-speed 1.2s linear infinite; }
  .ia-speed.s2 { animation-delay: 0.3s; }
  .ia-speed.s3 { animation-delay: 0.6s; }
  .ia-col { animation: ia-grow 3.2s var(--iw-ease, ease-out) infinite; }
  .ia-col.c2 { animation-delay: 0.12s; }
  .ia-col.c3 { animation-delay: 0.24s; }
  .ia-col.c4 { animation-delay: 0.36s; }
  .ia-trend { animation: ia-draw80 3.2s var(--iw-ease, ease-out) infinite; }
  .ia-ok { animation: ia-ok 3.4s var(--iw-ease, ease-out) infinite; }
  .ia-okring { animation: ia-ring 3.4s ease-out infinite; }
  .ia-spark { animation: ia-twinkle 2.6s ease-in-out infinite; }
  .ia-spark.k2 { animation-delay: 0.7s; }
  .ia-spark.k3 { animation-delay: 1.3s; }
  .ia-tap { animation: ia-tap 2.2s ease-in-out infinite; }
  .ia-write { animation: ia-write 4s var(--iw-ease, ease-out) infinite; stroke-dashoffset: 40; }
  .ia-write.w2 { animation-delay: 0.35s; }
  .ia-write.w3 { animation-delay: 0.7s; }
  .ia-write.w4 { animation-delay: 1.05s; }
  .ia-scan { animation: ia-scan 3.6s ease-in-out infinite; }
  .ia-sway { animation: ia-sway 2.4s ease-in-out infinite; }
  .ia-zap { animation: ia-blink 1.2s steps(2, jump-none) infinite; }
  .ia-layer { animation: ia-stack 1.8s var(--iw-ease, ease-out) infinite; }
  .ia-layer.y2 { animation-delay: 0.15s; }
  .ia-layer.y1 { animation-delay: 0.3s; }
  .ia-rise { animation: ia-rise 3s ease-in-out infinite; transform-origin: 50% 100%; }
  .ia-steam { animation: ia-steam 3s ease-out infinite; }
  .ia-steam.m2 { animation-delay: 0.6s; }
  .ia-steam.m3 { animation-delay: 1.2s; }
  .ia-drop { animation: ia-drop 2.4s cubic-bezier(0.55, 0, 0.6, 1) infinite; }
}

@keyframes ia-tick { 0%, 8% { stroke-dashoffset: 16; } 22%, 82% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: 0; opacity: 0; } }
@keyframes ia-bob { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
@keyframes ia-speed { 0% { transform: translateX(8px); opacity: 0; } 30% { opacity: 0.7; } 100% { transform: translateX(-10px); opacity: 0; } }
@keyframes ia-grow { 0% { transform: scaleY(0.15); } 30%, 80% { transform: scaleY(1); } 100% { transform: scaleY(0.15); } }
@keyframes ia-draw80 { 0%, 20% { stroke-dashoffset: 80; } 50%, 85% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: 0; opacity: 0; } }
@keyframes ia-ok { 0% { stroke-dashoffset: 40; } 25%, 85% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: 0; opacity: 0.2; } }
@keyframes ia-ring { 0% { transform: scale(0.9); opacity: 0.6; } 40% { transform: scale(1.12); opacity: 0; } 100% { opacity: 0; } }
@keyframes ia-twinkle { 0%, 100% { transform: scale(0.4) rotate(0deg); opacity: 0; } 50% { transform: scale(1) rotate(45deg); opacity: 1; } }
@keyframes ia-tap { 0%, 100% { transform: translate(0, 0); } 40% { transform: translate(-14px, -6px); } 55% { transform: translate(-14px, -6px) scale(0.9); } 70% { transform: translate(-14px, -6px); } }
@keyframes ia-write { 0%, 6% { stroke-dashoffset: 40; } 30%, 85% { stroke-dashoffset: 0; } 100% { stroke-dashoffset: 0; opacity: 0; } }
@keyframes ia-scan { 0%, 100% { transform: translate(0, 0); } 33% { transform: translate(-22px, -14px); } 66% { transform: translate(-30px, 4px); } }
@keyframes ia-sway { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(-3px); } }
@keyframes ia-blink { 0% { opacity: 1; } 100% { opacity: 0.15; } }
@keyframes ia-stack { 0% { transform: translateY(-10px); opacity: 0; } 35%, 80% { transform: none; opacity: 1; } 100% { opacity: 0; } }
@keyframes ia-rise { 0%, 100% { transform: scale(1, 1); } 50% { transform: scale(1.04, 1.12); } }
@keyframes ia-steam { 0% { transform: translateY(4px); opacity: 0; } 40% { opacity: 0.6; } 100% { transform: translateY(-8px); opacity: 0; } }
@keyframes ia-drop { 0% { transform: translateY(-6px) rotate(0deg); opacity: 0; } 15% { opacity: 1; } 65% { transform: translateY(40px) rotate(20deg); opacity: 1; } 80%, 100% { transform: translateY(40px) rotate(20deg); opacity: 0; } }
</style>
